<div [ngClass]="{ 'warning' : PageTitle === 'WARNING' }" mat-dialog-title style="margin:0px;">{{PageTitle}}</div>


    <mat-dialog-content>

        <div *ngIf="PageTitle === 'WARNING'">
            <p class='warning'>Changes have been entered but not saved.</p>
        </div>

        <div style="padding: 10px;">
                {{Message}}
        </div>

    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button *ngIf="PageTitle !== 'WARNING'" id="okButton" image="next arrow.png" label="Continue" (clickEvent)="okClick()"></tyl-button>
            <tyl-button *ngIf="PageTitle === 'WARNING'"id="okButton" image="save black.png" label="Save and Continue" (clickEvent)="okClick()"></tyl-button>
            <tyl-button *ngIf="PageTitle === 'WARNING'"id="okButton" image="next arrow.png" label="Continue Without Saving" (clickEvent)="continueWithoutSavingClick()"></tyl-button>
            <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>
